import { memo, useEffect } from 'react'
import { useAppDispatch } from 'store'
import { useFetchMarketPrice, useMarketPrice } from 'store/market/hooks'
import { TradeType } from 'store/market/types'
import { updateCreateOrderOption } from 'store/spot/actions'
import { useCurrentSpotSymbol, useSpotOrderDirection } from 'store/spot/hooks'
import { toFixed } from 'utils/number'

export const SpotMarketPriceInput = memo(() => {
  const dispatch = useAppDispatch()
  const currentSymbol = useCurrentSpotSymbol()
  const { id = 0, quoteScale = 0, name = '' } = currentSymbol
  const orderDirection = useSpotOrderDirection()

  useFetchMarketPrice(TradeType.Spot, id)

  const marketPrice = useMarketPrice(name)

  useEffect(() => {
    const price = marketPrice[orderDirection]
    if (price) {
      dispatch(
        updateCreateOrderOption({
          option: 'limitPrice',
          value: toFixed(price, quoteScale),
        }),
      )
    }
  }, [marketPrice, orderDirection])

  return null
})
